import { BiSolidDownArrow } from 'react-icons/bi';
import { useEmployeeFormContext } from '../EmployeeDocumentsSection';
import { Card, Text, TextInput, rem } from '@mantine/core';
import { isEmptyForm } from '@/utils/functions';
import { DateInput, type DateValue } from '@mantine/dates';
import { dateFormat, dateFormatUI } from '@/index';
import dayjs from 'dayjs';
import SectionErrorNotification from '@/components/Section/SectionErrorNotification';

export const IdentityCard: React.FC = () => {
  const form = useEmployeeFormContext();
  const icon = (
    <BiSolidDownArrow
      style={{ width: rem(10), height: rem(10), color: 'gray' }}
    />
  );
  if (isEmptyForm(form)) return <SectionErrorNotification />;

  const badge = form.values.cards.find(card => card.type === 'badge');

  function handleDateChange(date: string) {
    const updatedCards = [...form.values.cards];
    const index = form.values.cards.findIndex(card => card.type === 'badge');

    if (index !== -1) {
      updatedCards[index] = {
        ...updatedCards[index],
        issAt: date,
      };
    } else {
      const newBadge = {
        type: 'badge',
        issAt: date,
        expAt: '',
        deposit: '',
      };
      updatedCards.push(newBadge);
    }
    form.setFieldValue('cards', updatedCards);
  }

  const handleDepositChange = (newDeposit: string) => {
    const index = form.values.cards.findIndex(card => card.type === 'badge');
    const updatedCards = [...form.values.cards];

    if (index !== -1) {
      updatedCards[index] = {
        ...updatedCards[index],
        deposit: newDeposit,
      };
    } else {
      const newMealVoucher = {
        type: 'badge',
        issAt: '',
        expAt: '',
        deposit: newDeposit,
      };
      updatedCards.push(newMealVoucher);
    }
    form.setFieldValue('cards', updatedCards);
  };

  const setDate = (date: DateValue) => {
    handleDateChange(dayjs(date).format());
  };

  return (
    <Card shadow="sm" padding="md" radius="md" withBorder>
      <Text fw={700} size="lg">
        Osobní průkaz
      </Text>

      <DateInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="datum vydání"
        label="Datum vydání"
        rightSection={icon}
        valueFormat={dateFormatUI}
        value={badge ? dayjs(badge.issAt, dateFormat).toDate() : undefined}
        onChange={setDate}
        locale="cs"
      />
      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="číslo průkazu"
        label="Číslo průkazu"
        disabled={!badge}
        value={badge?.deposit ? badge.deposit : ''}
        onChange={e => handleDepositChange(e.target.value)}
      />
    </Card>
  );
};
